import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import NoConversionImg from "../assets/No-Conversion-Img.png";
import FlameDifference from "../assets/FlameDifference.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import "./Homepage.css";

// import { useNavigate } from 'react-router-dom';
import slide1 from "../assets/Home-Page-Banner-1.jpeg";
import slide2 from "../assets/Home-Page-Banner-2.jpeg";
import slide3 from "../assets/Home-Page-Banner-3.jpeg";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
// import Categories from "./Categories";

// import CustomizationComponent from "./customization";
import TornadoRings from "./tornado_new";
import SEOHead from "../seo/SEOHead";
import { PAGE_SEO } from "../seo/seoConfig";
import { websiteSchema, organizationSchema, pngStoveFaqSchema } from "../seo/structuredData";

const HomePage = () => {
  // const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
 const navigate = useNavigate();
  const slides = [slide1, slide2, slide3];

  // Function to handle search button click
  // const handleSearchClick = () => {
  //   navigate('/shop?focus=true');
  // };
 const handleShopNow = () => {
    navigate('/product/png-stove');
  };
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <SEOHead
        title={PAGE_SEO.home.title}
        description={PAGE_SEO.home.description}
        keywords={PAGE_SEO.home.keywords}
        canonical={PAGE_SEO.home.canonical}
        ogImage={PAGE_SEO.home.ogImage}
        ogType="website"
        structuredData={[websiteSchema, organizationSchema, pngStoveFaqSchema]}
      />
      <div className="homepage">
        {isLoading}

        {/* Swiper Carousel */}
        <div className="carousel-container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={800}
            className="image-carousel"
          >
            {slides.map((slide, index) => {
              const slideAlts = [
                "RealFlame PNG stove for home - High efficiency PNG stove for kitchen",
                "Premium PNG-compatible stove made specifically for PNG gas pipelines",
                "RealFlame PNG stove manufacturer - Durable PNG stoves for home"
              ];
              return (
                <SwiperSlide key={index}>
                  <div className="slide-image-container">
                    <img
                      src={slide}
                      alt={slideAlts[index] || `RealFlame PNG stove slide ${index + 1}`}
                      className="slide-image"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        <div className="promo-section">
          <div className="promo-card">
            <img
              src={NoConversionImg}
              alt="RealFlame PNG stove - Made specifically for PNG with no LPG-to-PNG conversion required"
              className="promo-image"
              loading="lazy"
            />
          </div>

          <div className="promo-card">
            <img
              src={FlameDifference}
              alt="RealFlame premium PNG stove efficiency and flame performance"
              className="promo-image promo-image-right"
              loading="lazy"
            />
          </div>
        </div>

        {/* SEO Intro Section for PNG Stove Intent */}
        <section className="seo-intro-section">
          <div className="seo-intro-container">
            <h1 className="seo-main-heading">
              India's Trusted <span className="highlight">PNG Stove Manufacturer</span>
            </h1>
            <p className="seo-intro-description">
              RealFlame is a leading PNG stove manufacturer producing high-performance PNG stoves engineered for modern households. Every premium PNG stove in our lineup is made specifically for PNG gas pipelines, offering maximum energy efficiency, flame stability, and long-lasting durability with no LPG-to-PNG conversion required. Whether you are looking for a 2-burner, 3-burner, or 4-burner PNG stove for home, our PNG-compatible stove models provide a safe, reliable PNG stove for kitchen spaces across India.
            </p>
          </div>
        </section>
          <div className="product-actions">
            <button className="product-action-btn primary" onClick={handleShopNow}>
              Shop Now
            </button>
          </div>
        {/* <Categories /> */}
        {/* <CustomizationComponent /> */}
        <TornadoRings />

        {/* <TestimonialCarousel/> */}
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
